import { useState, useEffect } from "react";
import apiClient from "../../rest/api-client";
import * as Sentry from "@sentry/browser";
import { Tenant } from "../../domains/tenant";
import { ServiceRequest } from "../../utils/ServiceRequest/service-request";
import { useSearchParams } from "next/navigation";

export const useTenant = () => {
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const searchParams = useSearchParams();
  const { tenantSlug } = ServiceRequest(searchParams);

  useEffect(() => {
    (async () => {
      if (!tenantSlug) {
        return;
      }
      try {
        const res = await apiClient.fetchTenantBySlug(tenantSlug);
        setTenant(res);
      } catch (e) {
        if (e.status !== 404) {
          Sentry.captureException(e);
        }
      }
    })();
  }, [tenantSlug]);

  return tenant;
};
